import { useStoreState } from 'providers/StoreStateContext';
import { useEffect } from 'react';
import { IStandardEnum } from 'types/global/enum.interface';

export interface IUseTableColumnsVisibility<COLUMNS> {
  tableId: string;
  hide: (column: COLUMNS) => boolean;
  toogleColumn: (column: COLUMNS) => void;
  disable: (column: COLUMNS) => boolean;
}

export const useTableColumnsVisibility = <COLUMNS>(
  tableId: string,
  columns: IStandardEnum<COLUMNS>,
  minimumColumns: number = 2
): IUseTableColumnsVisibility<COLUMNS> => {
  const {
    changeTableConfig,
    toggleTableColumn,
    isTableColumnHidden,
    isTableColumnDisabled,
  } = useStoreState();

  const columnsNumber = Object.entries(columns).length * 0.5;

  useEffect(() => {
    changeTableConfig(tableId, {
      columnsNumber,
      minimumColumns,
    });
  }, [tableId, columnsNumber, minimumColumns]);

  return {
    tableId,
    hide: (column: COLUMNS) => isTableColumnHidden(tableId, column as number),
    toogleColumn: (column: COLUMNS) =>
      toggleTableColumn(tableId, column as number),
    disable: (column: COLUMNS) =>
      isTableColumnDisabled(tableId, column as number),
  };
};
